import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyClipboard from 'vuetify-clipboard-input';

Vue.config.productionTip = false


const firebaseConfig = {
    apiKey: "AIzaSyCEO7D28Vt7NinhPpVCxuoNYTrlPvuxXdc",
    authDomain: "world-cup-manager.firebaseapp.com",
    databaseURL: "https://world-cup-manager-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "world-cup-manager",
    storageBucket: "world-cup-manager.appspot.com",
    messagingSenderId: "420437628444",
    appId: "1:420437628444:web:f9051d07274ddd8c14f1d9"
  };

Vue.use(VuetifyClipboard);
Vue.use(Vuetify);


firebase.initializeApp(firebaseConfig)

firebase.auth().onAuthStateChanged(user => {
    store.commit('updateUser', {user})
});



new Vue({
    vuetify: new Vuetify(),
    router: router,
    render: h => h(App)
}).$mount('#app');
